<template>
    <div class="blog_backgroud">
        <div class="blog_layout">
            <div class="blog_container">
                <header>
                    <h1><router-link to="/"><img src="@/assets/img/blog/logo.png" alt="logo" ></router-link></h1>
                    <div class="search">
                        <AutoComplete
                            v-model="searchItem"
                            :suggestions="filteredItems"
                            optionLabel="name"
                            @complete="search"
                            @keyup.enter="goToBlogPage"
                        />
                        <button type="button" @click="goToBlogPage">
                            <i class="pi pi-search"></i>
                        </button>
                    </div>
                </header>
            
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import AutoComplete from 'primevue/autocomplete';
import { supabase } from '@/API/supabase';

export default {
    name: 'Blog Layout',
    data() {
        return {
            searchItem: null,
            dataList: [],
            filteredItems: [],
        }
    },
    components: {
        AutoComplete
    },
    mounted() {
        this.getList();
    },
    watch: {
        '$route.params.useruid': {
            handler(newUid, oldUid) {
                if (newUid !== oldUid) {
                    this.emitter.emit('changeUseruid', newUid);
                }
            },
            immediate: true // 컴포넌트가 처음 로드될 때도 실행되게
        }
    },
    methods: {

        // 리스트 가져오기
        async getList(){

            try {
                const { data, error } = await supabase.rpc('get_speaker_blog_list', {
                    pm_schtext: null,
                })
                if (error) {
                    console.error('블로그 정보를 불러오는 중 오류 발생:', error);
                } else {
                    // console.log("Blog List : ",data);
                    var dataList = [];

                    for(var i = 0; i < data.length; i++){
                        var item = data[i];

                        dataList.push({
                            name: item.firstname + " " + item.lastname,
                            code: item.useruid,
                        });
                    }
                    this.dataList = dataList;

                }
            } catch (error) {
                console.error('블로그 정보를 불러오는 중 오류 발생:', error);
            }
        },

        // 검색
        search(event) {
            const query = event.query.toLowerCase().replace(/\s+/g, '');
            this.filteredItems = this.dataList.filter(item => 
                item.name.toLowerCase().replace(/\s+/g, '').startsWith(query)
            );
        },

        // 블로그 페이지 이동
        goToBlogPage() {
            
            if(this.searchItem == null || this.searchItem == ""){
                alert("Please select a speaker.");
                return;
            }

            let selectedSpeaker = null;

            if (typeof this.searchItem === 'object' && this.searchItem !== null) {
                selectedSpeaker = this.searchItem;
            } else {
                // 문자열로 검색 (공백 제거 후 매칭)
                const cleanedSearch = this.searchItem.toLowerCase().replace(/\s+/g, '');
                selectedSpeaker = this.dataList.find(item => 
                    item.name.toLowerCase().replace(/\s+/g, '') === cleanedSearch
                );
            }

            if (!selectedSpeaker) {
                alert("It doesn't match with any speaker. Please select a speaker again.");
                return;
            }
            
            var useruid = selectedSpeaker.code;
            this.$router.push({ name: 'blog', params: { useruid: useruid } });
        },

    }

}
</script>
